import { gql } from '@apollo/client'

export default gql(`
    mutation deleteAssetType($id: ID! $project: String) {
        deleteAssetType(
            input: {
                id: $id
            }
            project: $project
        ) {
            id
        }
    }`
)
